import { CourseInfo } from 'common/src/api/core/courses/types'

export const sortCourses = (
    courseInfoA: CourseInfo,
    courseInfoB: CourseInfo
): number => {
    // if starts with 'GH', then sort to the front (if both start with GH, then sort on abbreviation)
    // if starts with 'CP', then sort to the back (if both start with CP, then sort on abbreviation)
    // otherwise, sort by abbreviation
    if (courseInfoA.abbreviation.startsWith('GH')) {
        return courseInfoB.abbreviation.startsWith('GH')
            ? courseInfoA.abbreviation.localeCompare(courseInfoB.abbreviation)
            : -1
    } else if (courseInfoA.abbreviation.startsWith('CP')) {
        return courseInfoB.abbreviation.startsWith('CP')
            ? courseInfoA.abbreviation.localeCompare(courseInfoB.abbreviation)
            : 1
    } else {
        return courseInfoA.abbreviation.localeCompare(courseInfoB.abbreviation)
    }
}
